export enum ENodeType {
  Table = 'Table',
  Divider = 'Divider',
  Image = 'Image',
  Text = 'Text',
  Form = 'Form',
}

export enum CellType {
  ImageAndText = 'ImageAndText',
  ImageOnly = 'ImageOnly',
  TextOnly = 'TextOnly',
}

export enum ERowType {
  Columns = 'Columns',
  Standard = 'Standard',
  SideBySide = 'SideBySide',
}

export enum EDividerType {
  Dashed = 'Dashed',
  Thin = 'Thin',
  Thick = 'Thick',
  Transparent = 'Transparent',
}

export enum EDividerPadding {
  None = 'None',
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large',
}

export enum EImageSize {
  Full = 'Full',
  Half = 'Half',
  Original = 'Original',
  Cover = 'Cover',
}

export enum EImageAlign {
  Left = 'Left',
  Right = 'Right',
  Center = 'Center',
}
